export default __webpack_public_path__ + "static/media/TeamsAssets-Light.14c3e6f0.eot";